import API_BASE from "../config/api";

export const requestCustomerLedgerBalance = async (clientIp) => {
  const token = localStorage.getItem("token");

  const response = await fetch(
    `${API_BASE}/Customer/RequestLedgerBalance?client_ip=${clientIp}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Token": token,
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to request ledger balance");
  }

  return await response.json();
};